module.exports = __webpack_public_path__ + "img/edit.87bfb68c.svg";